import React from 'react';
import AppImage from '@/components/ui/AppImage';

interface TestimonialSnippetProps {
  quote: string;
  name: string;
  age: number;
  photoSrc: string;
  photoAlt: string;
}

export default function TestimonialSnippet({
  quote,
  name,
  age,
  photoSrc,
  photoAlt,
}: TestimonialSnippetProps) {
  return (
    <div className="flex items-start gap-3 sm:gap-4 p-4 sm:p-6 bg-white/10 backdrop-blur-md rounded-xl sm:rounded-2xl border border-white/20">
      <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-full overflow-hidden shrink-0 ring-2 ring-white/30">
        <AppImage src={photoSrc} alt={photoAlt} className="w-full h-full object-cover" />
      </div>
      <div>
        <p className="text-white text-xs sm:text-sm leading-relaxed italic mb-2">"{quote}"</p>
        <div className="text-white/80 text-xs font-medium">
          {name}, {age}
        </div>
      </div>
    </div>
  );
}